import { Container, Nav, Navbar, Dropdown, NavDropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Navbar.module.css";
import { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { logout } from "../redux/userSlice";
import { toast } from "react-toastify";

function Header({ user, handleShow }) {
  const [categories, setCategories] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logoutSuccessful = () => toast.info("You logged out!");

  useEffect(() => {
    const getCategory = async () => {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/categories` || 8000,
        method: "GET",
      });
      setCategories(response.data);
    };
    getCategory();
  }, []);

  const destroySession = () => {
    dispatch(logout());
    logoutSuccessful();
    navigate("/");
  };

  return (
    <Navbar
      className={styles.navbar + " p-0 g-0"}
      id="navbar"
      collapseOnSelect
      expand="lg"
      bg="dark"
      variant="dark"
      fixed="top"
    >
      <Container className="ps-0 pe-0">
        <Navbar.Brand className={styles.brand_name + " ms-2"}>
          <Nav.Link
            as={Link}
            eventKey="home"
            to={"/"}
            className={styles.brand_name}
          >
            KSURF
          </Nav.Link>
        </Navbar.Brand>
        <Navbar.Toggle className="me-2" aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <NavDropdown
              title="Categories"
              id="collasible-nav-dropdown"
              className={styles.dropdown_categories + " ps-2"}
            >
              {categories.map((category) => {
                return (
                  <NavDropdown.Item
                    eventKey={category.name}
                    key={category._id}
                    as={Link}
                    to={`/category/${category.name}`}
                    className={styles.link_category}
                  >
                    {category.name}
                  </NavDropdown.Item>
                );
              })}
            </NavDropdown>
          </Nav>
          <Nav className="ms-auto">
            <Nav.Link
              className={styles.navbar_link}
              to={"/about"}
              as={Link}
              eventKey="about"
            >
              About this project
            </Nav.Link>
            {!user.token ? (
              <Nav.Link
                as={Link}
                to={"/login"}
                className={styles.navbar_link}
                eventKey="login"
              >
                Login
              </Nav.Link>
            ) : (
              <NavDropdown
                title={<i className="fa-regular fa-circle-user"></i>}
                id="collasible-nav-dropdown"
                className={styles.dropdown_categories + " ps-2"}
              >
                <NavDropdown.Item
                  eventKey="profile"
                  as={Link}
                  to="/profile"
                  className={styles.link_category}
                >
                  Profile
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventKey="orders"
                  as={Link}
                  to="/orders"
                  className={styles.link_category}
                >
                  Your orders
                </NavDropdown.Item>
                <Dropdown.Divider className="mt-1 mb-1" />
                <NavDropdown.Item
                  eventKey="logout"
                  as={Link}
                  onClick={destroySession}
                  className={styles.link_category}
                >
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            )}
            <a
              className={styles.navbar_link}
              href="https://adminksurf-hackacademy.vercel.app/"
              target={"_blank"}
              rel="noreferrer"
              eventkey="admin"
            >
              Admin
            </a>
            <Nav.Link
              as="button"
              onClick={handleShow}
              className={styles.navbar_cart + " " + styles.navbar_link}
              eventKey="cart"
            >
              <i
                className={"fa-solid fa-cart-shopping " + styles.cart_icon}
              ></i>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
